var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99967,
    cy: 8.00065,
    r: 6,
    stroke: "#3451D7",
    strokeWidth: 1.33333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00033,
    cy: 10.4993,
    r: 0.833333,
    fill: "#3451D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 6.33333C6.33301 5.59695 7.0792 5 7.99967 5C8.92015 5 9.66634 5.59695 9.66634 6.33333C9.66634 6.97877 9.09307 7.5171 8.33164 7.64022C8.14991 7.6696 7.99967 7.81591 7.99967 8V8.33333",
    stroke: "#3451D7",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.ba5304f1da5cc5cd6d66e6c9c523be70.svg";
export { ForwardRef as ReactComponent };